import { Component, OnInit } from '@angular/core';
import { ColaboradorVincularCartaoFormComponent } from './colaborador-vincular-cartao-form/colaborador-vincular-cartao-form.component';

@Component({
  selector: 'app-colaborador-vincular-cartao',
  templateUrl: './colaborador-vincular-cartao.component.html',
  styleUrls: ['./colaborador-vincular-cartao.component.css']
})
export class ColaboradorVincularCartaoComponent implements OnInit {

    collaborator: any;
    collaboratorName: string;

    constructor() { }

    ngOnInit() {
        if(sessionStorage.getItem('currentCollaborator') != null){
            this.collaborator = JSON.parse(sessionStorage.getItem('currentCollaborator'));
            this.collaboratorName = this.collaborator.name;
        }
    }

}
